import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { Ref } from "vue";
import ConfigService, { IConfig } from "../services/ConfigService.ts";

export type ConfigStoreState = {
  config: Ref<IConfig | null>;
};

export const useConfigStore = defineStore("config", () => {
  let configService: ConfigService | null = null;

  // State
  const state: ConfigStoreState = {
    config: ref<IConfig | null>(null)
  };

  // Getters
  const getters = {
    getConfig: computed(() => state.config.value)
  };

  // Actions
  async function init(): Promise<void> {
    console.log("configStore.init()");
    configService = await ConfigService.init();
    console.log("configStore.init()", configService);

    state.config.value = configService.config;
  }

  async function reload(): Promise<void> {
    const _config = ConfigService.instance;
    await _config.reload();
    state.config.value = _config.config;
  }

  return {
    // State
    ...state,

    // Getters
    ...getters,

    // Actions
    init,

    reload
  };
});

export default useConfigStore;
